var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHostel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 14.9993H15V16.6659H10.8333V16.2493C10.8333 15.5601 11.3942 14.9993 12.0833 14.9993ZM13.75 8.3326H12.0833C11.3942 8.3326 10.8333 8.89343 10.8333 9.5826V9.99927H15V9.5826C15 8.89343 14.4392 8.3326 13.75 8.3326ZM5 11.6659H15V13.3326H12.0833C10.475 13.3326 9.16667 14.6409 9.16667 16.2493V16.6659H5V11.6659ZM5.83333 14.5826C5.83333 15.2726 6.39333 15.8326 7.08333 15.8326C7.77333 15.8326 8.33333 15.2726 8.33333 14.5826C8.33333 13.8926 7.77333 13.3326 7.08333 13.3326C6.39333 13.3326 5.83333 13.8926 5.83333 14.5826ZM15 18.3326H5V19.9993H15V18.3326ZM20 8.1026V15.8326C20 17.8443 18.5658 19.5276 16.6667 19.9151V9.5826C16.6667 7.97427 15.3583 6.66593 13.75 6.66593H12.0833C10.475 6.66593 9.16667 7.97427 9.16667 9.5826V9.99927H5V7.49927C5 7.03927 4.62667 6.66593 4.16667 6.66593C3.70667 6.66593 3.33333 7.03927 3.33333 7.49927V19.9151C1.43417 19.5276 0 17.8451 0 15.8326V8.1026C0 6.7151 0.686667 5.42426 1.83583 4.64843L7.66917 0.711764C9.085 -0.243236 10.915 -0.243236 12.3308 0.711764L18.1642 4.64843C19.3133 5.42426 20 6.7151 20 8.1026ZM8.33333 7.91593C8.33333 7.22593 7.77333 6.66593 7.08333 6.66593C6.39333 6.66593 5.83333 7.22593 5.83333 7.91593C5.83333 8.60593 6.39333 9.16593 7.08333 9.16593C7.77333 9.16593 8.33333 8.60593 8.33333 7.91593Z",
    fill: "url(#paint0_linear_192_489)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_192_489",
    x1: 10,
    y1: -0.00448608,
    x2: 10,
    y2: 19.9993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostel);
export default __webpack_public_path__ + "static/media/hostel.6a1a36dcc99ee98e7e348ce5676e157e.svg";
export { ForwardRef as ReactComponent };